import type { IChallenge } from "@bbj-types/challenge";
import type { ISocialOffer } from "@bbj-types/offer";

export const formatConcernedChallenges = (
  offer: Pick<ISocialOffer, "tags">,
  challenges: Pick<IChallenge, "name" | "tags">[]
) => {
  if (!offer.tags) {
    return "";
  }
  const map = offer.tags.reduce((map, tag) => {
    map[tag] = true;
    return map;
  }, {});
  return challenges.reduce((text, challenge) => {
    if (challenge.tags.some((tag) => map[tag])) {
      return text ? `${text}, ${challenge.name}` : challenge.name;
    }
    return text;
  }, "");
};

export const socialOfferDate = (offer: ISocialOffer, timeZone: string) => {
  return `${offer?.serviceStartDate?.toLocaleString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone,
  })} - ${offer?.serviceEndDate?.toLocaleString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone,
  })}`;
};
